// Mock data & localStorage helpers for BB Consórcios - Representante Autorizado
// NOTE: All data here is MOCKED using browser localStorage until backend is wired up.

export const ADMIN_CREDENTIALS = {
  username: "admin",
  password: "bbconsorcios2025",
};

export const brazilianStates = [
  "AC", "AL", "AP", "AM", "BA", "CE", "DF", "ES", "GO", "MA", "MT", "MS",
  "MG", "PA", "PB", "PR", "PE", "PI", "RJ", "RN", "RS", "RO", "RR", "SC",
  "SP", "SE", "TO",
];

export const estadoCivilOptions = [
  "Solteiro(a)", "Casado(a)", "Divorciado(a)", "Viúvo(a)", "União Estável",
];

export const nacionalidadeOptions = [
  "Brasileira", "Estrangeira",
];

export const experienciaOptions = [
  "Nenhuma", "Menos de 1 ano", "1 a 3 anos", "3 a 5 anos", "Mais de 5 anos",
];

export const areaAtuacaoOptions = [
  "Imóveis", "Veículos", "Serviços", "Pesados", "Outros",
];

export const comoConheceuOptions = [
  "Indicação", "Redes Sociais", "Google", "Anúncio", "Evento", "Outro",
];

export const tipoContaOptions = ["Conta Corrente", "Conta Poupança"];

// Multi-step form configuration (fields rendered dynamically)
export const formSteps = [
  {
    title: "Informações Pessoais",
    subtitle: "Preencha seus dados pessoais para iniciar o cadastro",
    fields: [
      { name: "foto", label: "Foto (Opcional)", type: "file", required: false, fullWidth: true },
      { name: "primeiroNome", label: "Primeiro Nome", type: "text", required: true, placeholder: "Ex: João" },
      { name: "sobrenome", label: "Sobrenome", type: "text", required: true, placeholder: "Ex: Silva" },
      { name: "telefone", label: "Telefone com DDD (após o 55)", type: "text", required: true, placeholder: "55 (11) 98888-7777" },
      { name: "whatsapp", label: "WhatsApp", type: "text", required: true, placeholder: "55 (11) 98888-7777", hint: 'Informe seu número de WhatsApp com "DDD" para receber avisos.' },
      { name: "email", label: "Informe seu melhor e-mail", type: "email", required: true, placeholder: "seuemail@exemplo.com", hint: "Após cadastrado, o e-mail não poderá ser alterado!", fullWidth: true },
      { name: "cpf", label: "CPF", type: "text", required: true, placeholder: "000.000.000-00" },
      { name: "rg", label: "RG", type: "text", required: true, placeholder: "00.000.000-0", hint: "Favor informar o RG com o órgão expedidor." },
      { name: "dataNascimento", label: "Data de Nascimento", type: "text", mask: "date", required: true, placeholder: "DD/MM/AAAA" },
      { name: "nacionalidade", label: "Nacionalidade", type: "select", required: true, options: nacionalidadeOptions },
      { name: "estadoCivil", label: "Estado Civil", type: "select", required: true, options: estadoCivilOptions },
    ],
  },
  {
    title: "Endereço",
    subtitle: "Onde você mora atualmente",
    fields: [
      { name: "cep", label: "CEP", type: "text", required: true, placeholder: "00000-000" },
      { name: "logradouro", label: "Logradouro", type: "text", required: true, placeholder: "Rua / Avenida" },
      { name: "numero", label: "Número", type: "text", required: true, placeholder: "123" },
      { name: "complemento", label: "Complemento", type: "text", required: false, placeholder: "Apto, bloco..." },
      { name: "bairro", label: "Bairro", type: "text", required: true, placeholder: "Centro" },
      { name: "cidade", label: "Cidade", type: "text", required: true, placeholder: "São Paulo" },
      { name: "estado", label: "Estado", type: "select", required: true, options: brazilianStates },
    ],
  },
  {
    title: "Dados Profissionais",
    subtitle: "Dados da empresa e experiência",
    fields: [
      { name: "profissao", label: "Profissão", type: "text", required: true, placeholder: "Ex: Corretor" },
      { name: "empresa", label: "Razão Social (Opcional)", type: "text", required: false, placeholder: "Razão social da empresa" },
      { name: "nomeFantasia", label: "Nome Fantasia", type: "text", required: true, placeholder: "Nome fantasia da empresa" },
      { name: "cnpj", label: "CNPJ", type: "text", required: true, placeholder: "00.000.000/0000-00" },
      { name: "experienciaVendas", label: "Experiência com Vendas", type: "select", required: true, options: experienciaOptions },
      { name: "areaAtuacao", label: "Área de Atuação", type: "select", required: true, options: areaAtuacaoOptions },
      { name: "comoConheceu", label: "Como conheceu a BB Consórcios?", type: "select", required: true, options: comoConheceuOptions, fullWidth: true },
    ],
  },
  {
    title: "Dados Bancários",
    subtitle: "Para recebimento de comissões",
    fields: [
      { name: "banco", label: "Banco", type: "text", required: true, placeholder: "Ex: Banco do Brasil" },
      { name: "agencia", label: "Agência", type: "text", required: true, placeholder: "0000-0" },
      { name: "conta", label: "Conta", type: "text", required: true, placeholder: "00000-0" },
      { name: "tipoConta", label: "Tipo de Conta", type: "select", required: true, options: tipoContaOptions },
      { name: "chavePix", label: "Chave PIX (Opcional)", type: "text", required: false, placeholder: "CPF, e-mail, telefone...", fullWidth: true },
    ],
  },
  {
    title: "Documentações",
    subtitle: "Envie os documentos solicitados (PDF ou imagem)",
    fields: [
      { name: "docRgCpf", label: "RG e CPF (ou CNH)", type: "file", required: true, fullWidth: true },
      { name: "docComprovanteEndereco", label: "Comprovante de Endereço", type: "file", required: true, fullWidth: true },
      { name: "docAlteracaoContratual", label: "Última alteração contratual", type: "file", required: true, fullWidth: true },
      { name: "docContratoSocial", label: "Contrato Social ou Certificado MEI", type: "file", required: true, fullWidth: true },
      { name: "docContaCorrente", label: "Comprovante Conta Corrente (Pessoa Jurídica)", type: "file", required: true, fullWidth: true },
      { name: "docInscricaoCadastral", label: "Comprovante de Inscrição Cadastral (CNPJ)", type: "file", required: true, fullWidth: true },
      { name: "observacoes", label: "Observações (Opcional)", type: "textarea", required: false, placeholder: "Alguma informação adicional?", fullWidth: true },
      { name: "aceiteTermos", label: "Li e aceito os Termos de Uso e as condições do programa de Representante Autorizado BB Consórcios.", type: "checkbox", required: true, fullWidth: true },
      { name: "aceiteLgpd", label: "Autorizo o tratamento dos meus dados pessoais conforme a Lei Geral de Proteção de Dados (LGPD).", type: "checkbox", required: true, fullWidth: true },
    ],
  },
];

export const allFieldDefs = formSteps.flatMap((s) => s.fields);

// ---------------- localStorage helpers (MOCK persistence) ----------------
const STORAGE_KEY = "bb_consorcios_partners";

const seedPartners = [
  {
    id: "seed-1",
    primeiroNome: "Mariana", sobrenome: "Oliveira",
    telefone: "55 (11) 98877-6655", whatsapp: "55 (11) 98877-6655",
    email: "mariana.oliveira@email.com", cpf: "123.456.789-00", rg: "12.345.678-9 SSP/SP",
    dataNascimento: "1990-05-14", nacionalidade: "Brasileira", estadoCivil: "Casado(a)",
    cep: "01310-100", logradouro: "Av. Paulista", numero: "1000", complemento: "Cj 101",
    bairro: "Bela Vista", cidade: "São Paulo", estado: "SP",
    profissao: "Corretora de Imóveis", empresa: "Oliveira Imóveis",
    experienciaVendas: "Mais de 5 anos", areaAtuacao: "Imóveis", comoConheceu: "Indicação",
    banco: "Banco do Brasil", agencia: "1234-5", conta: "56789-0", tipoConta: "Conta Corrente",
    chavePix: "mariana.oliveira@email.com",
    observacoes: "Tenho carteira ativa de clientes.", aceiteTermos: true, aceiteLgpd: true,
    masterCode: "andre", masterName: "André Souza",
    createdAt: "2025-06-20T10:30:00.000Z",
  },
  {
    id: "seed-2",
    primeiroNome: "Carlos", sobrenome: "Mendes",
    telefone: "55 (21) 99988-1122", whatsapp: "55 (21) 99988-1122",
    email: "carlos.mendes@email.com", cpf: "987.654.321-00", rg: "98.765.432-1 DETRAN/RJ",
    dataNascimento: "1985-11-02", nacionalidade: "Brasileira", estadoCivil: "Solteiro(a)",
    cep: "20031-170", logradouro: "Av. Rio Branco", numero: "156", complemento: "",
    bairro: "Centro", cidade: "Rio de Janeiro", estado: "RJ",
    profissao: "Consultor de Vendas", empresa: "",
    experienciaVendas: "3 a 5 anos", areaAtuacao: "Veículos", comoConheceu: "Redes Sociais",
    banco: "Banco do Brasil", agencia: "4321-0", conta: "09876-5", tipoConta: "Conta Poupança",
    chavePix: "55021999881122",
    observacoes: "", aceiteTermos: true, aceiteLgpd: true,
    masterCode: "carla", masterName: "Carla Lima",
    createdAt: "2025-07-01T14:05:00.000Z",
  },
];

function ensureSeed() {
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(seedPartners));
  }
}

export function getPartners() {
  ensureSeed();
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
  } catch {
    return [];
  }
}

export function getPartnerById(id) {
  return getPartners().find((p) => p.id === id) || null;
}

export function savePartner(data) {
  const partners = getPartners();
  const newPartner = {
    ...data,
    id: `p-${Date.now()}`,
    createdAt: new Date().toISOString(),
  };
  partners.unshift(newPartner);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(partners));
  return newPartner;
}

export function updatePartner(id, data) {
  const partners = getPartners();
  const idx = partners.findIndex((p) => p.id === id);
  if (idx === -1) return null;
  partners[idx] = { ...partners[idx], ...data, id };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(partners));
  return partners[idx];
}

export function deletePartner(id) {
  const partners = getPartners().filter((p) => p.id !== id);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(partners));
  return true;
}


// ---------------- MASTERS (mock persistence) ----------------
const MASTERS_KEY = "bb_consorcios_masters";

const seedMasters = [
  { id: "m-1", name: "André Souza", code: "andre", email: "andre@bbconsorcios.com", phone: "55 (11) 90000-0001", createdAt: "2025-05-10T09:00:00.000Z" },
  { id: "m-2", name: "Carla Lima", code: "carla", email: "carla@bbconsorcios.com", phone: "55 (21) 90000-0002", createdAt: "2025-05-12T09:00:00.000Z" },
];

function ensureMasterSeed() {
  if (!localStorage.getItem(MASTERS_KEY)) {
    localStorage.setItem(MASTERS_KEY, JSON.stringify(seedMasters));
  }
}

// Turn a name/text into a clean URL slug: "André Souza" -> "andre-souza"
export function slugify(str) {
  return String(str || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 40);
}

function uniqueCode(masters, desired, ignoreId = null) {
  let base = desired || "master";
  let final = base;
  let i = 2;
  while (masters.some((m) => m.code.toLowerCase() === final && m.id !== ignoreId)) {
    final = `${base}-${i++}`;
  }
  return final;
}

export function getMasters() {
  ensureMasterSeed();
  try {
    return JSON.parse(localStorage.getItem(MASTERS_KEY)) || [];
  } catch {
    return [];
  }
}

export function getMasterByCode(code) {
  if (!code) return null;
  return getMasters().find((m) => m.code.toLowerCase() === String(code).toLowerCase()) || null;
}

export function saveMaster(data) {
  const masters = getMasters();
  const desired = slugify(data.code || data.name);
  const code = uniqueCode(masters, desired);
  const newMaster = { ...data, code, id: `m-${Date.now()}`, createdAt: new Date().toISOString() };
  masters.unshift(newMaster);
  localStorage.setItem(MASTERS_KEY, JSON.stringify(masters));
  return newMaster;
}

export function updateMaster(id, data) {
  const masters = getMasters();
  const idx = masters.findIndex((m) => m.id === id);
  if (idx === -1) return null;
  const patch = { ...data };
  if (data.code !== undefined) {
    patch.code = uniqueCode(masters, slugify(data.code || data.name), id);
  }
  masters[idx] = { ...masters[idx], ...patch, id };
  localStorage.setItem(MASTERS_KEY, JSON.stringify(masters));
  return masters[idx];
}

export function deleteMaster(id) {
  const masters = getMasters().filter((m) => m.id !== id);
  localStorage.setItem(MASTERS_KEY, JSON.stringify(masters));
  return true;
}

// Count how many partners belong to each master code
export function countPartnersByMaster(code) {
  return getPartners().filter((p) => p.masterCode === code).length;
}
